var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"overlay",on:{"click":_vm.toggle}}),_c('div',{staticClass:"modal-card"},[_c('button',{staticClass:"close-btn",on:{"click":_vm.toggle}},[_c('i',{staticClass:"fas fa-times"})]),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }